import './CustomRolesModal.scss';

export { default } from './CustomRolesModal';
